// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1RnO6","savePackageButton":"ClientWallet_savePackageButton__2JhHn"};